var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-sound"},[_c('audio',{attrs:{"id":"theTrialSound","playsinline":"","preload":"auto","src":_vm.notificationUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }